export interface LogEntry {
  id: string;
  timestamp: string;
  level: string;
  category: string;
  message: string;
  exception?: string;
  eventId?: number;
  properties?: Record<string, any>;
  machineName: string;
  applicationName: string;
  documentFileName?: string;
}

export interface LogsResponse {
  logs: LogEntry[];
  totalCount: number;
  hasMore: boolean;
}

export interface LogStats {
  collectionStats: {
    totalDocuments: number;
    sizeInBytes: number;
    averageDocumentSize: number;
    storageSize: number;
  };
  ttlIndex: {
    exists: boolean;
    retentionDays: number;
  };
  logCounts: {
    total: number;
    last30Days: number;
    last7Days: number;
    last24Hours: number;
  };
  oldestLog: string | null;
  currentTime: string;
  isCleanupWorking: boolean;
}

export interface LogFilters {
  level?: string;
  category?: string;
  startDate?: Date;
  endDate?: Date;
  limit: number;
  messageSearch?: string;
  documentFileName?: string;
}

export const LOG_LEVELS = [
  'Trace',
  'Debug', 
  'Information',
  'Warning',
  'Error',
  'Critical'
] as const;

export type LogLevel = typeof LOG_LEVELS[number];

export const LOG_LEVEL_COLORS: Record<LogLevel, string> = {
  'Trace': '#9E9E9E',      // Gray
  'Debug': '#607D8B',      // Blue Gray
  'Information': '#2196F3', // Blue
  'Warning': '#FF9800',    // Orange
  'Error': '#F44336',      // Red
  'Critical': '#9C27B0'    // Purple
}; 